module.exports = __webpack_public_path__ + "static/media/firebase.ebfe98c9.png";